<template>
  <div class="productWrap">
    <div class="pageBgSty">
      <div class="pageTitle">产品中心</div>
      <div class="pageTitleTips">基于传感器技术、物联网技术、音视频技术、AI智能识别技术，形成新一代大气监测智能化产品</div>
    </div>
    <div class="contentWrapFist">
      <div class="nav-wrap">
        <div class="nav-inner">
          <div class="nav-item" :class="{active:index==activeIndex}" v-for="(item,index) in list" :key="index" @click="handleClick(index)" v-html="item"></div>
        </div>
      </div>
    </div>
    <div class="imgConWrap">
<!--      <component :is="currentCom" ></component>-->
      <img class="img_content" v-for="(item,index) in imgArr" v-if="index==activeIndex" :key="index" :src="item" alt="">
    </div>
  </div>
</template>

<script>
  /*import com0 from "./components/com0";
  import com1 from "./components/com1";
  import com2 from "./components/com2";
  import com3 from "./components/com3";
  import com4 from "./components/com4";*/
  import com0 from "./components/imgs/com0.jpg";
  import com1 from "./components/imgs/com1.jpg";
  import com2 from "./components/imgs/com2.jpg";
  import com3 from "./components/imgs/com3.jpg";
  import com4 from "./components/imgs/com4.jpg";
  export default {
    components: {

    },
    data(){
      return{
        activeIndex: 0,
        currentCom:"com0",
        imgArr:[com0,com1,com2,com3,com4],
        list:["边缘计算<br>智能终端","固定式AI<br>环境监测站" ,"车载式AI<br>环境监测站" ,"便携式AI<br>环境监测站","无人机机载式<br>AI环境监测站"],
      }
    },
    methods: {
      handleClick(index) {
        this.activeIndex=index
        this.currentCom="com"+index
      }
    },
    watch: {

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .productWrap
    width 100%
    .pageBgSty
      width 100%
      height 500px
      background url("~@/assets/imgs/page_bg_product.jpg") no-repeat
      background-size 100% 100%
      display flex
      align-items center
      justify-content center
      flex-direction column
      color white
      .pageTitle
        font-size 30px
        letter-spacing 3px
        margin-bottom 15px
      .pageTitleTips
        letter-spacing 2px
        font-size 20px
    .imgConWrap
      width 1288px
      margin 0 auto
      padding  50px 0
      .img_content
        width 100%
      .imgWrap
        display flex
        align-items center
        width 100%
        .imgSty
          max-height 500px
          margin 0 30px
    .contentWrapFist
      width 100%
      margin 0 auto
      position relative
      padding-top 60px
      .nav-wrap
        position absolute
        top -10px
        height 76px
        width 100%
        border-bottom 1px solid #E5E5E5
        display flex
        justify-content center
        .nav-inner
          width 1288px
          display flex
          align-items center
          height 100%
          .nav-item
            flex 1
            height 100%
            display flex
            align-items center
            justify-content center
            padding-top 5px
            box-sizing border-box
            color #888888
            font-size 20px
            cursor pointer
            line-height 25px
            &:hover
              background-color #3E85F1
              color white
          .active
            background-color #3E85F1
            color white
</style>



// WEBPACK FOOTER //
// src/views/product/product.vue